import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class ProgramAdditionStateSelectComponent implements IController {
  value: any;
  parentValue: any;
  onChange: Function;


  getCurrentClass() {
    return _.isUndefined(_.get(this.value, 'enabled')) ? (!!this.parentValue.enabled ? 'enabled' : 'disabled') :
      (!!this.value.enabled ? 'enabled' : 'disabled');
  }

  getCurrentValue() {
    const text = _.get(this.value, 'enabled') ? 'Enabled' : 'Disabled';
    return _.isUndefined(_.get(this.value, 'enabled')) ? 'Linked to parent' : text;
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('programAdditionStateSelect', {
    bindings: {
      value: '<',
      parentValue: '<?',
      onChange: '&'
    },
    template: require('./program-addition-state-select.html').default,
    controller: ProgramAdditionStateSelectComponent
  });
